import lang from '../lang';

const MenuItems = {
    AdminSchool: [
        {
            title: lang.menu?.dashboard || "Dashboard",
            activeClass: "dashboard",
            // icon: "ti-dashboard",
            icon: "fas fa-tachometer-alt font-18 icon-side-bar",
            url: '/ad-sas-school/dashboard-ban-giam-hieu',
            permission: "U0",
            isShow: true,
            children: []
        },
        {
            title: lang.menu?.chatManagement || "Tin nhắn",
            activeClass: "chat-management",
            icon: "fas fa-comments font-18 icon-side-bar",
            url: '/ad-sas-school/chat',
            // permission: "CHAT0",
            permission: "SS0",
            isShow: false,
            children: []
        },
        {
            title: lang.menu?.notificationManagement || "Quản lý thông báo",
            activeClass: "noti-management",
            icon: "fas fa-solid fa-bell font-18 icon-side-bar",
            url: '/ad-sas-school/quan-ly-thong-bao',
            permission: "NF0", // Updated: N0 → NF0 (NOTIFICATION_VIEW)
            isShow: false,
        },
        {
            title: lang.menu?.newsManagement || "Quản lý tin tức",
            activeClass: "news-management",
            icon: "fas fa-mobile-alt fa-bell font-18 icon-side-bar",
            url: '/ad-sas-school/quan-ly-tin-tuc',
            permission: "N0", // Updated: NE0 → N0 (NEWS_VIEW)
            isShow: false,
        },
        {
            title: lang.menu?.teacherAttendance || "Điểm danh lớp chủ nhiệm",
            activeClass: "teacher-attendance",
            icon: "fas fa-chalkboard-teacher font-18 icon-side-bar",
            url: '/ad-sas-school/diem-danh-lop-chu-nhiem',
            permission: "DD0", // Sử dụng quyền điểm danh
            isShow: false,
        },
        {
            title: lang.menu?.personalTimekeeping || "Chấm công cá nhân",
            activeClass: "timekeeping-teacher",
            icon: "fas fa-user-clock font-18 icon-side-bar",
            url: '/ad-sas-school/cham-cong-ca-nhan',
            permission: "U0",
            isShow: false,
            children: []
        },
        {
            title: lang.menu?.studentLeaveRequest || "Xin nghỉ phép hộ h/s",
            activeClass: "xin-nghi-ho-hs",
            icon: "fas fa-user-minus font-18 icon-side-bar",
            url: '/ad-sas-school/xin-nghi-hoc-sinh',
            permission: "DD0",
            isShow: false,
            children: []
        },
        {
            title: lang.menu?.attendance || "Điểm danh",
            activeClass: "attendance-management",
            icon: " fas fa-user-check font-18 icon-side-bar",
            permission: "ST0|Y0|UG0|U0", // Updated: S0→ST0, GU0→UG0
            isShow: false,
            children: [
                {
                    title: lang.menu?.dailyAttendance || "Điểm danh hàng ngày",
                    activeClass: "attendance-everyday",
                    parentClass: "attendance-management",
                    icon: "caret",
                    url: '/ad-sas-school/diem-danh',
                    permission: "DD0", // Updated: GU0 → DD0 (DIEM_DANH_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.leaveRequest || "Xin nghỉ phép hộ h/s",
                    activeClass: "xin-nghi",
                    parentClass: "attendance-management",
                    icon: "caret",
                    url: '/ad-sas-school/xin-nghi-hoc-sinh',
                    permission: "DD0", // Updated: GU0 → DD0 (or keep as general permission)
                    isShow: false,
                },
                {
                    title: lang.menu?.mealAttendance || "Điểm danh ăn",
                    activeClass: "attendance-eat",
                    parentClass: "attendance-management",
                    icon: "caret",
                    url: '/ad-sas-school/diem-danh-an',
                    permission: "EC0", // Updated: GU0 → EC0 (EAT_CHECK_VIEW)
                    isShow: false,
                },

                {
                    title: lang.menu?.latePickupAttendance || "Điểm danh đón muộn",
                    activeClass: "attendance-late-pick-up",
                    parentClass: "attendance-management",
                    icon: "caret",
                    url: '/ad-sas-school/diem-danh-don-muon',
                    permission: "LPR0", // Updated: GU0 → LPR0 (LATE_PICK_UP_RECEIVE_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.clbAttendance || "Điểm danh CLB",
                    activeClass: "attendance-clb",
                    parentClass: "attendance-management",
                    icon: "caret",
                    url: '/ad-sas-school/diem-danh-clb',
                    permission: "CLBC0", // Updated: GU0 → CLBC0 (CLB_CHECK_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.attendanceReport || "Báo cáo điểm danh",
                    activeClass: "attendance-report",
                    parentClass: "attendance-management",
                    icon: "caret",
                    url: '/ad-sas-school/bao-cao-diem-danh-hang-ngay',
                    permission: "DD0", // Updated: GU0 → DD0 (DIEM_DANH_VIEW with report)
                    isShow: false,
                },
                {
                    title: lang.menu?.clbAttendanceReport || "Báo cáo điểm danh CLB",
                    activeClass: "attendance-report-clb",
                    parentClass: "attendance-management",
                    icon: "caret",
                    url: '/ad-sas-school/bao-cao-diem-danh-clb',
                    permission: "CLBRP0", // Updated: GU0 → CLBRP0 (CLB_REPORT_CHECK_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.mealReport || "Báo cáo ăn",
                    activeClass: "eat-report",
                    parentClass: "attendance-management",
                    icon: "caret",
                    url: '/ad-sas-school/bao-cao-an',
                    permission: "ERP0", // Updated: GU0 → EGR0 (EAT_REPORT_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.lunchReport || "Báo cáo suất ăn trưa",
                    activeClass: "lunch-report",
                    parentClass: "attendance-management",
                    icon: "caret",
                    url: '/ad-sas-school/bao-cao-suat-an-trua',
                    permission: "EC0", // EAT_CHECK_VIEW
                    isShow: false,
                }
            ]
        },
        {
            title: lang.menu?.mealManagement || "Quản lý ăn/Nghỉ",
            activeClass: "eat-management",
            icon: "fas fa-hamburger font-18 icon-side-bar",
            permission: "ET0|ER0", // Updated: GU0 → ET0 (EAT_TYPE_VIEW), ER0 (EAT_REGISTER_VIEW)
            isShow: false,
            children: [
                {
                    title: lang.menu?.mealService || "Quản lý dịch vụ ăn",
                    activeClass: "eat-list",
                    parentClass: "eat-management",
                    icon: "caret",
                    url: '/ad-sas-school/danh-sach-dich-vu-an',
                    permission: "ET0", // Updated: GU0 → ET0 (EAT_TYPE_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.mealRegister || "Đăng ký ăn",
                    activeClass: "eat-register",
                    parentClass: "eat-management",
                    icon: "caret",
                    url: '/ad-sas-school/dang-ky-an-hoc-sinh',
                    permission: "ER0", // Updated: GU0 → ER0 (EAT_REGISTER_VIEW)
                    isShow: false,
                }
            ]
        },
        {
            title: lang.menu?.parentManagement || "Quản lý phụ huynh",
            activeClass: "phu-huynh-management",
            icon: "fas fa-users font-18 icon-side-bar",
            permission: "P0", // Updated: SG0 → P0 (PARENT_VIEW)
            isShow: false,
            children: [
                {
                    title: lang.menu?.parentList || "Danh sách phụ huynh",
                    activeClass: "phu-huynh",
                    parentClass: "phu-huynh-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-phu-huynh',
                    permission: "P0", // Updated: SG0 → P0 (PARENT_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.parentLink || "Liên kết phụ huynh",
                    activeClass: "map-phu-huynh",
                    parentClass: "phu-huynh-management",
                    icon: "caret",
                    url: '/ad-sas-school/lien-ket-phu-huynh',
                    permission: "P0", // Updated: SG0 → P0 (PARENT_VIEW)
                    isShow: false,
                }
            ]
        },

        {
            title: lang.menu?.smsManagement || "Tin nhắn SMS/Gmail",
            activeClass: "sms-management",
            icon: "fas fa-sms font-18 icon-side-bar",
            permission: "SMS0|SMSS0", // Updated: SM0 → SMS0 (SMS_VIEW), EM0 → SMSS0 (SMS_SEND_VIEW)
            isShow: false,
            children: [
                {
                    title: lang.menu?.sendExternalSms || "Quản lý gửi tin nhắn ngoài",
                    activeClass: "sms-send-outside",
                    parentClass: "sms-management",
                    icon: "caret",
                    url: '/ad-sas-school/gui-tin-nhan-ngoai-he-thong',
                    permission: "SMS0", // Updated: SM0 → SMS0 (SMS_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.sendAdvertisingEmail || "Quản lý gửi Email quảng cáo",
                    activeClass: "gmail-send",
                    parentClass: "sms-management",
                    icon: "caret",
                    url: '/ad-sas-school/danh-sach-email-quang-cao',
                    permission: "SMSS0", // Updated: EM0 → SMSS0 (SMS_SEND_VIEW)
                    isShow: false,
                },
            ]
        },
        {
            title: lang.menu?.admissionsManagement || "Quản lý tuyển sinh",
            activeClass: "admissions-management",
            icon: "fas fa-user-plus font-18 icon-side-bar",
            permission: "QC0|QCA0|QCG0", // Note: These are QLTS module permissions - may need separate handling
            isShow: false,
            children: [
                {
                    title: lang.menu?.statusNameManagement || "Quản lý tên trạng thái",
                    activeClass: "admissions-name-status",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/tuyen-sinh/quan-ly-ten-trang-thai',
                    permission: "QCG0",
                    isShow: false,
                },
                {
                    title: lang.menu?.customerGroupManagement || "Quản lý nhóm khách hàng",
                    activeClass: "admissions-group-permission",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/tuyen-sinh/quan-ly-nhom-khach-hang',
                    permission: "QCG0",
                    isShow: false,
                },
                {
                    title: lang.menu?.enrollmentCampaign || "Chiến dịch tuyển sinh",
                    activeClass: "enrollment-campaign",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/tuyen-sinh/chien-dich-tuyen-sinh',
                    permission: "QCA0",
                    isShow: false,
                },
                {
                    title: lang.menu?.customerList || "Danh sách khách hàng",
                    activeClass: "list-customer-admissions",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/tuyen-sinh/danh-sach-khach-hang',
                    permission: "QC0",
                    isShow: false,
                },
                {
                    title: lang.menu?.admissionsReport || "Báo cáo",
                    activeClass: "payment-report-admissions",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/tuyen-sinh/bao-cao',
                    permission: "QCA6",
                    isShow: false,
                },
            ]
        },
        {
            title: lang.menu?.timekeepingConfig || "Cấu hình chấm công",
            activeClass: "config-timekeeping-management",
            icon: "far fa-calendar-alt font-18 icon-side-bar",
            permission: "SCH0|Y0|UG0|U0|DEPT0", // Updated: S0→SCH0, GU0→UG0, D0→DEPT0
            isShow: false,
            children: [
                {
                    title: lang.menu?.config || "Cấu hình",
                    activeClass: "config-management",
                    parentClass: "config-timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-cham-cong',
                    permission: "Y0|DEPT0", // Updated: D0 → DEPT0
                    isShow: false,
                },
                {
                    title: lang.menu?.workShift || "Ca làm việc",
                    activeClass: "shift-management",
                    parentClass: "config-timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-ca-lam-viec',
                    permission: "SH0", // Updated: Y0|D0 → SH0 (SHIFT_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.workCalendar || "Quản lý lịch làm việc",
                    activeClass: "work-calendar",
                    parentClass: "config-timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-lich-lam-viec',
                    // permission: "WC0", // WORK_CALENDAR_VIEW
                    permission: "TA0", // Updated: Y0|D0 → TA0 (TEACHER_ASSIGNMENT_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.teachingAssignment || "Phân công giảng dạy",
                    activeClass: "teacher-assignment",
                    parentClass: "config-timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-phan-cong-giang-day',
                    permission: "TA0", // Updated: Y0|D0 → TA0 (TEACHER_ASSIGNMENT_VIEW)
                    isShow: false,
                },
                {
                    id: "supplementary-work",
                    title: lang.menu?.supplementaryWork || "Quản lý việc bổ sung",
                    url: "/ad-sas-school/cong-viec-bo-sung",
                    activeClass: "supplementary-work-management",
                    parentClass: "config-timekeeping-management",
                    permission: "SW0" // Updated: Y0|D0 → SW0 (SUPPLEMENTARY_WORK_VIEW)
                },

                {
                    id: "event",
                    title: lang.menu?.eventAssignment || "Phân công sự kiện",
                    url: "/ad-sas-school/quan-ly-su-kien",
                    activeClass: "event-management",
                    parentClass: "config-timekeeping-management",
                    permission: "E0" // Updated: Y0|D0 → E0 (EVENT_VIEW)
                },
                {
                    title: lang.menu?.attendanceZone || "Quản lý vùng chấm công",
                    activeClass: "attendance-location-management",
                    parentClass: "config-timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-vung-cham-cong',
                    permission: "AL0", // Updated: GU0 → AL0 (ATTENDANCE_LOCATION_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.attendanceWifi || "Quản lý wifi chấm công",
                    activeClass: "attendance-wifi",
                    parentClass: "config-timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-wifi-cham-cong',
                    permission: "TK0", // Updated: GU0 → TK0 (TIMEKEEPING_VIEW - wifi config related)
                    isShow: false,
                }
            ]
        },

        {
            title: lang.menu?.timekeeping || "Chấm công",
            activeClass: "timekeeping-management",
            icon: "far fa-calendar-alt font-18 icon-side-bar",
            permission: "TK0|AL0|SL0|U0", // Updated: S0→TK0, GU0→AL0/SL0
            isShow: false,
            children: [
                {
                    title: lang.menu?.leaveApplication || "Đơn xin nghỉ",
                    activeClass: "application-leave-management",
                    parentClass: "timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-don-xin-nghi',
                    permission: "AL0", // Updated: GU0 → AL0 (APPLICATION_LEAVE_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.officerLeaveBalance || "Quản lý phép nhân viên",
                    activeClass: "officer-leave-balance-management",
                    parentClass: "timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-phep-nhan-vien',
                    permission: "TK0", // TIMEKEEPING:VIEW
                    isShow: false,
                },
                {
                    id: "swap-lesson-list",
                    title: lang.menu?.swapLesson || "Đơn đổi tiết",
                    url: "/ad-sas-school/quan-ly-doi-tiet",
                    activeClass: "swap-lesson-management",
                    parentClass: "timekeeping-management",
                    permission: "SL0" // Updated: GU0 → SL0 (SWAP_LESSON_VIEW)
                },

                {
                    title: lang.menu?.timekeepingList || "Chấm công",
                    activeClass: "timekeeping-list",
                    parentClass: "timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-cham-cong',
                    permission: "TK0", // Updated: GU0 → TK0 (TIMEKEEPING_VIEW)
                    isShow: false,
                },

                {
                    title: lang.menu?.complaintApproval || "Duyệt khiếu nại",
                    activeClass: "application-leave-approval",
                    parentClass: "timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-don-khieu-nai-cham-cong',
                    permission: "ST0", // Updated: GU0 → ST0 (SUPPLEMENTARY_TIMEKEEPING_VIEW for complaints)
                    isShow: false,
                },
                {
                    title: lang.menu?.staffTimekeepingView || "NV xem chấm công",
                    activeClass: "timekeeping-report-review",
                    parentClass: "timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/nhan-vien-kiem-tra-cham-cong',
                    permission: "U0",
                    isShow: false,
                },
                {
                    title: lang.menu?.staffLessonView || "NV xem chấm tiết",
                    activeClass: "my-lesson-consolidation",
                    parentClass: "timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/bao-cao-cham-tiet-cua-toi',
                    permission: "U0",
                    isShow: false,
                },
                {
                    title: lang.menu?.timekeepingReport || "Báo cáo chấm công",
                    activeClass: "timekeeping-report",
                    parentClass: "timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/bao-cao-cham-cong',
                    permission: "TKR", // Updated: U0 → TKR (TIMEKEEPING_REPORT)
                    isShow: false,
                },
                {
                    title: lang.menu?.lessonReport || "Báo cáo chấm tiết",
                    activeClass: "timekeeping-teacher-lesson-report",
                    parentClass: "timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/bao-cao-cham-tiet',
                    permission: "TLC0", // Updated: U0 → TLC0 (TEACHER_LESSON_CONSOLIDATION_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.lessonComplaint || "Quản lý khiếu nại chấm tiết",
                    activeClass: "lesson-complaint-management",
                    parentClass: "timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/khieu-nai-cham-tiet',
                    permission: "LC0", // Updated: U0 → LC0 (LESSON_COMPLAINT_VIEW)
                    isShow: true,
                }
            ]
        },
        {
            title: lang.menu?.timetableManagement || "Thời khóa biểu",
            activeClass: "timetable-management",
            icon: "fas fa-calendar-alt font-18 icon-side-bar",
            permission: "SS0|TA0", // SUBJECT_SCHEDULE_VIEW, TEACHER_ASSIGNMENT_VIEW
            isShow: false,
            children: [
                {
                    title: lang.menu?.schedule || "Thời khóa biểu",
                    activeClass: "schedule-management",
                    parentClass: "timetable-management",
                    icon: "caret",
                    url: '/ad-sas-school/thoi-khoa-bieu',
                    permission: "SS0", // SUBJECT_SCHEDULE_VIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.autoTimetable || "Sinh TKB tự động",
                    activeClass: "auto-timetable",
                    parentClass: "timetable-management",
                    icon: "caret",
                    url: '/ad-sas-school/sinh-tkb',
                    permission: "TA0", // TEACHER_ASSIGNMENT_VIEW - related to timetable
                    isShow: false,
                },
                {
                    title: lang.menu?.timetableConstraints || "Ràng buộc TKB",
                    activeClass: "timetable-constraints",
                    parentClass: "timetable-management",
                    icon: "caret",
                    url: '/ad-sas-school/rang-buoc-tkb',
                    permission: "TA0", // TEACHER_ASSIGNMENT_VIEW - related to timetable
                    isShow: false,
                }
            ]
        },
        {
            title: lang.menu?.lessonPlanManagement || "Quản lý bài giảng",
            activeClass: "lesson-plan-management",
            icon: "fas fa-chalkboard-teacher font-18 icon-side-bar",
            // permission: "LP0|LP3", // LP0: LESSON_PLAN_VIEW, LP3: LESSON_PLAN_REVIEW
            permission: "SS0", // LP0: LESSON_PLAN_VIEW, LP3: LESSON_PLAN_REVIEW
            isShow: false,
            children: [
                {
                    title: lang.menu?.lessonPlanList || "Danh sách bài giảng",
                    activeClass: "lesson-plan-list",
                    parentClass: "lesson-plan-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-bai-giang',
                    // permission: "LP0", // LESSON_PLAN_VIEW
                    permission: "SS0", // LESSON_PLAN_VIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.lessonPlanReview || "Kiểm duyệt bài giảng",
                    activeClass: "lesson-plan-review",
                    parentClass: "lesson-plan-management",
                    icon: "caret",
                    url: '/ad-sas-school/kiem-duyet-bai-giang',
                    // permission: "LP3", // LESSON_PLAN_REVIEW
                    permission: "SS0", // LESSON_PLAN_REVIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.cloudStorage || "Kết nối Cloud Storage",
                    activeClass: "cloud-storage",
                    parentClass: "lesson-plan-management",
                    icon: "caret",
                    url: '/ad-sas-school/ket-noi-cloud-storage',
                    // permission: "LP0", // LESSON_PLAN_VIEW
                    permission: "SS0", // LESSON_PLAN_VIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.resourceLibrary || "Thư viện tài nguyên",
                    activeClass: "resource-library",
                    parentClass: "lesson-plan-management",
                    icon: "caret",
                    url: '/ad-sas-school/thu-vien-tai-nguyen',
                    // permission: "LP0", // LESSON_PLAN_VIEW
                    permission: "SS0", // LESSON_PLAN_VIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.homeworkManagement || "Quản lý bài tập",
                    activeClass: "homework-management",
                    parentClass: "lesson-plan-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-bai-tap',
                    // permission: "LP0", // LESSON_PLAN_VIEW
                    permission: "SS0", // LESSON_PLAN_VIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.timetableSync || "Đồng bộ TKB",
                    activeClass: "timetable-sync",
                    parentClass: "lesson-plan-management",
                    icon: "caret",
                    url: '/ad-sas-school/dong-bo-tkb',
                    // permission: "LP0", // LESSON_PLAN_VIEW
                    permission: "SS0", // LESSON_PLAN_VIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.lessonPlanStatistics || "Thống kê",
                    activeClass: "lesson-plan-statistics",
                    parentClass: "lesson-plan-management",
                    icon: "caret",
                    url: '/ad-sas-school/thong-ke-bai-giang',
                    // permission: "LP3", // LESSON_PLAN_REVIEW
                    permission: "SS0", // LESSON_PLAN_REVIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.batchOperations || "Thao tác hàng loạt",
                    activeClass: "batch-operations",
                    parentClass: "lesson-plan-management",
                    icon: "caret",
                    url: '/ad-sas-school/thao-tac-hang-loat',
                    // permission: "LP3", // LESSON_PLAN_REVIEW
                    permission: "SS0", // LESSON_PLAN_REVIEW
                    isShow: false,
                }
            ]
        },
        {
            title: lang.menu?.system || "Hệ thống",
            activeClass: "system-school-management",
            icon: "fas fa-school font-18 icon-side-bar",
            permission: "SCG0|SCH0|Y0|UG0|U0|CL0|ST0", // Updated: SG0→SCG0, S0→SCH0, GU0→UG0, CT0→CL0, STT0/STT1→ST0 (removed SS0 - moved to separate menu)
            isShow: false,
            children: [
                {
                    title: lang.menu?.schoolGroupManagement || "Quản lý nhóm trường",
                    activeClass: "list-group-school-management",
                    parentClass: "system-school-management",
                    icon: "caret",
                    url: '/ad-sas-school/danh-sach-nhom-truong',
                    permission: "SCG0", // Updated: SG0 → SCG0 (SCHOOL_GROUP_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.schoolManagement || "Quản lý trường học",
                    activeClass: "list-school-management",
                    parentClass: "system-school-management",
                    icon: "caret",
                    url: '/ad-sas-school/danh-sach-truong-hoc',
                    permission: "SCH0", // Updated: S0 → SCH0 (SCHOOL_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.dataDeclaration || "Khai báo dữ liệu",
                    activeClass: "declaration-management",
                    parentClass: "system-school-management",
                    icon: "caret",
                    url: '/ad-sas-school/khai-bao-du-lieu',
                    permission: "Y0|DEPT0|CL0", // Updated: D0→DEPT0, keep Y0 for year
                    isShow: false,
                },
                {
                    title: lang.menu?.dataTransfer || "Kết chuyển dữ liệu",
                    activeClass: "transfer-management",
                    parentClass: "system-school-management",
                    icon: "caret",
                    url: '/ad-sas-school/ket-chuyen-du-lieu',
                    permission: "CL0|ST0", // Updated: CT0→CL0 (CLASSROOM), STT0/STT1→ST0 (STUDENT)
                    isShow: false,
                },

                {
                    title: lang.menu?.permissionManagement || "Quản lý quyền",
                    activeClass: "permission-management",
                    parentClass: "system-school-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-quyen',
                    permission: "PG0", // PERMISSION_VIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.permissionGroupManagement || "Quản lý nhóm quyền",
                    activeClass: "permission-group-management",
                    parentClass: "system-school-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-nhom-quyen',
                    permission: "PG0", // PERMISSION_GROUP_VIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.userGroupPermission || "Phân quyền nhóm người dùng",
                    activeClass: "group-permission-management",
                    parentClass: "system-school-management",
                    icon: "caret",
                    url: '/ad-sas-school/phan-quyen-nhom-nguoi-dung',
                    permission: "UG0", // Updated: GU0 → UG0 (USER_GROUP_MANAGEMENT_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.userManagement || "Quản lý người dùng",
                    activeClass: "user-management",
                    parentClass: "system-school-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-nguoi-dung',
                    permission: "U0",
                    isShow: false,
                },
                {
                    title: lang.menu?.versionManagement || "Quản lý phiên bản",
                    activeClass: "app-version",
                    parentClass: "system-school-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-phien-ban',
                    permission: "U0",
                    isShow: false,
                }
            ]
        },
        {
            title: lang.menu?.studentManagement || "Quản lý học sinh",
            activeClass: "student-management",
            icon: "fas fa-graduation-cap font-18 icon-side-bar",
            permission: "DAZ0|DAR0|DAS0|ST0|SP0", // Updated: AA0→DAZ0, AR0→DAR0, AS0→DAS0, TSFY0→SP0
            isShow: false,
            children: [
                {
                    title: lang.menu?.admissionsZoneDiscount || "Cấu hình ưu đãi tuyển sinh khu vực",
                    activeClass: "admissions-zone",
                    parentClass: "student-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-uu-dai-tuyen-sinh-khu-vuc',
                    permission: "DAZ0", // Updated: AA0|SG0 → DAZ0 (DISCOUNT_ADMISSIONS_ZONE_VIEW)
                },
                {
                    title: lang.menu?.admissionsRegisterDiscount || "Cấu hình ưu đãi tuyển sinh ngày đăng ký",
                    activeClass: "admissions-register",
                    parentClass: "student-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-uu-dai-tuyen-sinh-ngay-dang-ky',
                    permission: "DAR0", // Updated: AR0 → DAR0 (DISCOUNT_ADMISSIONS_REGISTER_VIEW)
                },
                {
                    title: lang.menu?.specialDiscount || "Cấu hình ưu đãi đặc biệt",
                    activeClass: "admissions-special",
                    parentClass: "student-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-uu-dai-dac-biet',
                    permission: "DAS0", // Updated: AS0 → DAS0 (DISCOUNT_ADMISSIONS_SPECIAL_VIEW)
                },
                {
                    title: lang.menu?.studentProfile || "Hồ sơ học sinh",
                    activeClass: "student-info-management",
                    parentClass: "student-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-thong-tin-hoc-sinh',
                    permission: "ST0", // Keep ST0 (STUDENT_VIEW)
                },
                {
                    title: lang.menu?.firstYearClassAssignment || "Phân lớp học sinh đầu cấp",
                    activeClass: "accept-first-year",
                    parentClass: "student-management",
                    icon: "caret",
                    url: '/ad-sas-school/phan-lop-hoc-sinh-dau-cap',
                    permission: "ST0", // Keep as ST0 (student related)
                },
                {
                    title: lang.menu?.gradeManagement || "Quản lý điểm",
                    activeClass: "subject-point",
                    parentClass: "student-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-diem-hoc-sinh',
                    permission: "SP0", // Updated: U0 → SP0 (SUBJECT_POINT_VIEW)
                }, {
                    title: lang.menu?.finalGradeReport || "Báo cáo điểm tổng kết",
                    activeClass: "student-report-management",
                    parentClass: "student-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-bao-cao-diem-hoc-sinh',
                    permission: "STR0", // Updated: U0 → STR0 (STUDENT_REPORT_VIEW)
                },
            ]
        },
        {
            title: lang.menu?.staffManagement || "Quản lý cán bộ",
            activeClass: "staff-management",
            // icon: "flaticon-profile",
            icon: "fas fa-user-tie font-18",
            isShow: false,
            permission: "T0|O0", // Updated: CL0→T0 (TEACHER), CR0→O0 (OFFICER), CA0 removed
            children: [
                {
                    title: lang.menu?.staffList || "Quản lý cán bộ",
                    activeClass: "list-staff",
                    parentClass: "staff-management",
                    icon: "caret",
                    url: '/ad-sas-school/danh-sach-can-bo',
                    permission: "T0|O0", // Updated: CL0|CR0|CA0 → T0|O0
                },
            ]
        },
        {
            title: lang.menu?.feeManagement || "Quản lý chi phí",
            activeClass: "wallet-management",
            icon: "fas fa-wallet font-18 icon-side-bar",
            isShow: false,
            permission: "FFY0|F0|FR0|FFYR0|I0|U0", // Updated all fee codes + U0 for QR
            children: [
                {
                    title: lang.menu?.feeItems || "Các khoản phí",
                    activeClass: "fee-item",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-cac-khoan-phi',
                    permission: "FFY0", // Updated: FFY0 → FFYI0 (FEE_FIRST_YEAR_ITEM_VIEW)
                },
                {
                    title: lang.menu?.feeItemCollection || "Quản lý thu các khoản phí",
                    activeClass: "fee-item-manager",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-thu-khoan-phi',
                    permission: "FFY0", // Updated: FFYM0 → FFY0 (FEE_FIRST_YEAR_VIEW)
                },
                {
                    title: lang.menu?.tuitionConfig || "Cấu hình giá học phí",
                    activeClass: "fee",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-gia-hoc-phi',
                    permission: "F0", // Updated: FE0 → F0 (FEE_VIEW)
                },
                {
                    title: lang.menu?.tuitionReport || "Báo cáo thu học phí",
                    activeClass: "list-fee",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-hoc-phi-hoc-sinh',
                    permission: "FR0", // Updated: U0 → FR0 (FEE_REPORT_VIEW)
                },
                {
                    title: lang.menu?.feeCollectionReport || "Báo cáo thu các khoản phí",
                    activeClass: "fee-first-year-report",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/bao-cao-thu-phi',
                    permission: "FFYR0", // Updated: FFER0 → FFYR0 (FEE_FIRST_YEAR_REPORT_VIEW)
                },
                {
                    title: lang.menu?.receiptManagement || "Quản lý thu chi",
                    activeClass: "phieu-thu",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-phieu-thu',
                    permission: "I0", // Updated: WA0 → I0 (INVOICE_VIEW)
                },
                {
                    title: lang.menu?.vcbQrManagement || "Quản lý QR thanh toán",
                    activeClass: "vcb-qr",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-qr-thanh-toan',
                    permission: "I0", // I0: INVOICE_VIEW, U0: cho phép tất cả user
                    // permission: "I0|U0", // I0: INVOICE_VIEW, U0: cho phép tất cả user
                },
            ]
        },
        {
            title: lang.menu?.busManagement || "Quản lý xe bus",
            activeClass: "bus-management",
            icon: "fas fa-bus font-18 icon-side-bar",
            isShow: false,
            permission: "BRT0|BR0|BRG0|BRC0", // Updated all bus codes
            children: [
                {
                    title: lang.menu?.busServiceType || "Loại dịch vụ xe bus",
                    activeClass: "price-bus",
                    parentClass: "bus-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-loai-tuyen-xe-bus',
                    permission: "BT0", // Updated: BT0 → BRT0 (BUS_TYPE_VIEW)
                },
                {
                    title: lang.menu?.busRoute || "Tuyến xe bus",
                    activeClass: "list-bus",
                    parentClass: "bus-management",
                    icon: "caret",
                    url: '/ad-sas-school/danh-sach-tuyen-xe-bus',
                    permission: "BR0", // Updated: BU0 → BR0 (BUS_ROUTE_VIEW)
                },
                {
                    title: lang.menu?.busRegister || "Đăng ký xe bus",
                    activeClass: "register-bus",
                    parentClass: "bus-management",
                    icon: "caret",
                    url: '/ad-sas-school/danh-sach-dang-ky-xe-bus',
                    permission: "BRG0", // Updated: BR0 → BRG0 (BUS_REGISTER_VIEW)
                },
                {
                    title: lang.menu?.busRegisterRequest || "Yêu cầu đăng ký xe bus",
                    activeClass: "bus-registration-request",
                    parentClass: "bus-management",
                    icon: "caret",
                    url: '/ad-sas-school/yeu-cau-dang-ky-xe-bus',
                    permission: "BRG0", // Updated: BR0 → BRGR0 (BUS_REGISTRATION_REQUEST_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.busTracking || "Theo dõi xe bus",
                    activeClass: "bus-tracking",
                    parentClass: "bus-management",
                    icon: "caret",
                    url: '/ad-sas-school/theo-doi-xe-bus',
                    permission: "BR0", // BUS_ROUTE_VIEW - same permission as viewing bus routes
                    isShow: false,
                },
                {
                    title: lang.menu?.busAttendanceReport || "Báo cáo điểm danh xe bus",
                    activeClass: "report-bus",
                    parentClass: "bus-management",
                    icon: "caret",
                    url: '/ad-sas-school/diem-danh-xe-bus',
                    permission: "BC0", // Updated: BRRT → BRC0 (BUS_CHECK_VIEW)
                },
            ]
        },
        {
            title: lang.menu?.clbManagement || "Quản lý CLB",
            activeClass: "clb-management",
            icon: "fas fa-chess font-18 icon-side-bar",
            isShow: false,
            permission: "CLB0|CLBR0", // Updated: CL0→CLB0, CR0→CLBR0
            children: [
                {
                    title: lang.menu?.clbClass || "Quản lý lớp CLB",
                    activeClass: "class-clb",
                    parentClass: "clb-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-lop-clb',
                    permission: "CLB0", // Updated: CL0 → CLB0 (CLB_VIEW)
                },
                {
                    title: lang.menu?.clbRegister || "Quản lý đăng ký CLB",
                    activeClass: "register-clb",
                    parentClass: "clb-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-dang-ky-clb',
                    permission: "CLBR0", // Updated: CR0 → CLBR0 (CLB_REGISTER_VIEW)
                }
            ]
        },
        {
            title: lang.menu?.summerManagement || "Quản lý học hè",
            activeClass: "summer-management",
            icon: "fas fa-umbrella-beach font-18 icon-side-bar",
            isShow: false,
            permission: "SUM0|SUMR0", // Updated: CL0→SU0 (SUMMER), CR0→SUR0 (SUMMER_REGISTER)
            children: [
                {
                    title: lang.menu?.summerClass || "Quản lý lớp học hè",
                    activeClass: "class-summer",
                    parentClass: "summer-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-lop-hoc-he',
                    permission: "SUM0", // Updated: CL0 → SU0 (SUMMER_VIEW)
                },
                {
                    title: lang.menu?.summerRegister || "Quản lý đăng ký học hè",
                    activeClass: "register-summer",
                    parentClass: "summer-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-dang-ky-hoc-he',
                    permission: "SUMR0", // Updated: CR0 → SUR0 (SUMMER_REGISTER_VIEW)
                }
            ]
        },
        {
            title: lang.menu?.otherServiceManagement || "Quản lý dịch vụ khác",
            activeClass: "service-management",
            icon: "fas fa-clipboard font-18 icon-side-bar",
            isShow: false,
            permission: "SI0|SO0|SR0", // Updated all service codes
            children: [
                {
                    title: lang.menu?.productManagement || "Quản lý sản phẩm",
                    activeClass: "list-service-product",
                    parentClass: "service-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-san-pham-dich-vu',
                    permission: "SI0", // Updated: SP0 → SI0 (SERVICE_ITEM_VIEW)
                },
                {
                    title: lang.menu?.serviceManagement || "Quản lý dịch vụ",
                    activeClass: "list-service",
                    parentClass: "service-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-dich-vu-khac',
                    permission: "SO0", // Updated: SE0 → SO0 (SERVICE_OTHER_VIEW)
                },
                {
                    title: lang.menu?.serviceRegister || "Quản lý đăng ký dịch vụ",
                    activeClass: "register-service",
                    parentClass: "service-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-dang-ky-dich-vu',
                    permission: "SR0", // Updated: SR0 → SOR0 (SERVICE_OTHER_REGISTER_VIEW)
                }
            ]
        },

        {
            title: lang.menu?.latePickupManagement || "Quản lý đón muộn",
            activeClass: "late-pick-up-management",
            icon: "fas fa-clock font-18 icon-side-bar",
            isShow: false,
            permission: "LPC0|LPR0|LPRP0", // Updated all late pickup codes
            children: [
                {
                    title: lang.menu?.latePickupConfig || "Cấu hình giá đón muộn",
                    activeClass: "config-late",
                    parentClass: "late-pick-up-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-gia-don-muon',
                    permission: "LPC0", // Updated: LPUC0 → LPC0 (LATE_PICK_UP_CONFIG_VIEW)
                },
                {
                    title: lang.menu?.latePickupRegister || "Đăng ký đón muộn",
                    activeClass: "register-late",
                    parentClass: "late-pick-up-management",
                    icon: "caret",
                    url: '/ad-sas-school/danh-sach-dang-ky-don-muon',
                    permission: "LPR0", // Updated: LPUR0 → LPR0 (LATE_PICK_UP_REGISTER_VIEW)
                },
                {
                    title: lang.menu?.latePickupReport || "Báo cáo đón muộn",
                    activeClass: "report-pick-late-up",
                    parentClass: "late-pick-up-management",
                    icon: "caret",
                    url: '/ad-sas-school/bao-cao-don-muon',
                    permission: "LPRP0", // Updated: LPURT0 → LPRP0 (LATE_PICK_UP_REPORT_VIEW)
                }
            ]
        },

        {
            title: lang.menu?.nutritionManagement || "Quản lý dinh dưỡng",
            activeClass: "menu-management",
            // icon: "flaticon-profile",
            icon: "fas fa-mortar-pestle font-18",
            isShow: false,
            permission: "FOODT0|FOODG0|FOODS0|FOOD0|FOODE0|M0|MW0", // Updated all food codes
            children: [
                {
                    title: lang.menu?.foodType || "Loại thực phẩm",
                    activeClass: "food-type",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/loai-thuc-pham',
                    permission: "FOODT0", // Updated: FT0 → FOODT0 (FOOD_TYPE_VIEW)
                },
                {
                    title: lang.menu?.foodGroup || "Nhóm thực phẩm",
                    activeClass: "food-group",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/nhom-thuc-pham',
                    permission: "FOODG0", // Updated: FG0 → FOODG0 (FOOD_GROUP_VIEW)
                },
                {
                    title: lang.menu?.supplier || "Nhà cung cấp",
                    activeClass: "supplier",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/nha-cung-cap',
                    permission: "FOODS0", // Updated: FS0 → FOODS0 (FOOD_SUPPLIER_VIEW)
                },
                {
                    title: lang.menu?.food || "Thực phẩm",
                    activeClass: "food",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-thuc-pham',
                    permission: "FOOD0", // Updated: FO0 → FOOD0 (FOOD_VIEW)
                },
                {
                    title: lang.menu?.dish || "Món ăn",
                    activeClass: "food-eat",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-mon-an',
                    permission: "FOODE0", // Updated: FOE0 → FOODE0 (FOOD_EAT_VIEW)
                },
                {
                    title: lang.menu?.menuManagement || "Thực đơn",
                    activeClass: "menu",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-thuc-don',
                    permission: "M0", // KEEP: M0 (not in mapping, but used in menu)
                },
                {
                    title: lang.menu?.weeklyMenu || "Thực đơn tuần",
                    activeClass: "menu-week",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/thuc-don-tuan',
                    permission: "M0", // KEEP: MW0 (not in mapping, but used in menu)
                },
                {
                    title: lang.menu?.dailyMenu || "Thực đơn hàng ngày",
                    activeClass: "menu-daily",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/thuc-don-hang-ngay',
                    permission: "M0", // KEEP: Related to menu
                },
            ]
        },

        {
            title: lang.menu?.medicalManagement || "Quản lý y tế",
            activeClass: "medical-management",
            icon: "fas fa-clinic-medical font-18 icon-side-bar",
            permission: "MED0", // Updated: S0|Y0|GU0|U0 → MED0 (MEDICAL_VIEW)
            isShow: false,
            children: [
                {
                    title: lang.menu?.medicationManagement || "Dặn thuốc (cũ)",
                    activeClass: "list-medical-management",
                    parentClass: "medical-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-dan-thuoc',
                    permission: "MED0",
                    isShow: false,
                },
                {
                    title: lang.menu?.medicalRoom || "Khám phòng y tế",
                    activeClass: "medical-room",
                    parentClass: "medical-management",
                    icon: "caret",
                    url: '/ad-sas-school/kham-phong-y-te',
                    permission: "MED0",
                    isShow: false,
                },
                {
                    title: lang.menu?.healthRecord || "Hồ sơ sức khỏe",
                    activeClass: "health-record",
                    parentClass: "medical-management",
                    icon: "caret",
                    url: '/ad-sas-school/ho-so-suc-khoe',
                    permission: "MED0",
                    isShow: false,
                },
                {
                    title: lang.menu?.periodicExam || "Khám định kỳ",
                    activeClass: "periodic-exam",
                    parentClass: "medical-management",
                    icon: "caret",
                    url: '/ad-sas-school/kham-dinh-ky',
                    permission: "MED0",
                    isShow: false,
                },
                {
                    title: lang.menu?.examCampaign || "Đợt khám",
                    activeClass: "exam-campaign",
                    parentClass: "medical-management",
                    icon: "caret",
                    url: '/ad-sas-school/dot-kham',
                    permission: "MED0",
                    isShow: false,
                },
                {
                    title: lang.menu?.healthInsurance || "Bảo hiểm y tế",
                    activeClass: "health-insurance",
                    parentClass: "medical-management",
                    icon: "caret",
                    url: '/ad-sas-school/bao-hiem-y-te',
                    permission: "MED0",
                    isShow: false,
                },
                {
                    title: lang.menu?.vaccination || "Tiêm chủng",
                    activeClass: "vaccination",
                    parentClass: "medical-management",
                    icon: "caret",
                    url: '/ad-sas-school/tiem-chung',
                    permission: "MED0",
                    isShow: false,
                },
                {
                    title: lang.menu?.medicineManagement || "Quản lý thuốc",
                    activeClass: "medicine-management",
                    parentClass: "medical-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-thuoc',
                    permission: "MED0",
                    isShow: false,
                }
            ]
        },
        {
            title: lang.menu?.logManagement || "Quản lý LOG",
            activeClass: "log-management",
            icon: "fas fa-history font-18 icon-side-bar",
            isShow: false,
            url: '/ad-sas-school/log-management',
            permission: "SUPER_LOG_ALL",
        },
        {
            title: lang.menu?.inventoryManagement || "Quản lý kho",
            activeClass: "inventory-management",
            icon: "fas fa-boxes font-18 icon-side-bar",
            permission: "INV0|SUP0|PRD0|STI0|STO0",
            isShow: false,
            children: [
                {
                    title: lang.menu?.supplierCategory || "Danh mục NCC",
                    activeClass: "supplier-category-management",
                    parentClass: "inventory-management",
                    icon: "caret",
                    url: '/ad-sas-school/danh-muc-nha-cung-cap',
                    // permission: "SUP0",
                    permission: "INV0",
                    isShow: false,
                },
                {
                    title: lang.menu?.supplier || "Nhà cung cấp",
                    activeClass: "supplier-management",
                    parentClass: "inventory-management",
                    icon: "caret",

                    url: '/ad-sas-school/nha-cung-cap-kho',
                    // permission: "SUP0",
                    permission: "INV0",
                    isShow: false,
                },
                {
                    title: lang.menu?.productCategory || "Danh mục sản phẩm",
                    activeClass: "product-category-management",
                    parentClass: "inventory-management",
                    icon: "caret",
                    url: '/ad-sas-school/danh-muc-san-pham',
                    // permission: "PRD0",
                    permission: "INV0",
                    isShow: false,
                },
                {
                    title: lang.menu?.productUnit || "Đơn vị tính",
                    activeClass: "product-unit-management",
                    parentClass: "inventory-management",
                    icon: "caret",
                    url: '/ad-sas-school/don-vi-tinh',
                    // permission: "PRD0",
                    permission: "INV0",
                    isShow: false,
                },
                {
                    title: lang.menu?.product || "Sản phẩm",
                    activeClass: "product-management",
                    parentClass: "inventory-management",
                    icon: "caret",
                    url: '/ad-sas-school/san-pham',
                    // permission: "PRD0",
                    permission: "INV0",
                    isShow: false,
                },
                {
                    title: lang.menu?.warehouse || "Kho hàng",
                    activeClass: "warehouse-management",
                    parentClass: "inventory-management",
                    icon: "caret",
                    url: '/ad-sas-school/kho-hang',
                    permission: "INV0",
                    isShow: false,
                },
                {
                    title: lang.menu?.inventory || "Tồn kho",
                    activeClass: "inventory-list-management",
                    parentClass: "inventory-management",
                    icon: "caret",
                    url: '/ad-sas-school/ton-kho',
                    permission: "INV0",
                    isShow: false,
                },
                {
                    title: lang.menu?.stockIn || "Phiếu nhập kho",
                    activeClass: "stock-in-management",
                    parentClass: "inventory-management",
                    icon: "caret",
                    url: '/ad-sas-school/phieu-nhap-kho',
                    // permission: "STI0",
                    permission: "INV0",
                    isShow: false,
                },
                {
                    title: lang.menu?.stockOut || "Phiếu xuất kho",
                    activeClass: "stock-out-management",
                    parentClass: "inventory-management",
                    icon: "caret",
                    url: '/ad-sas-school/phieu-xuat-kho',
                    // permission: "STO0",
                    permission: "INV0",
                    isShow: false,
                },
            ]
        },
        {
            title: lang.menu?.assetManagement || "Quản lý tài sản",
            activeClass: "asset-management",
            icon: "fas fa-warehouse font-18 icon-side-bar",
            permission: "MED0",
            // permission: "AST0|ASTC0|ASTL0|ASTM0|ASTCK0|ASTDP0",
            isShow: false,
            children: [
                {
                    title: lang.menu?.assetCategory || "Danh mục tài sản",
                    activeClass: "asset-category",
                    parentClass: "asset-management",
                    icon: "caret",
                    url: '/ad-sas-school/danh-muc-tai-san',
                    // permission: "ASTC0",
                    permission: "MED0",
                    isShow: false,
                },
                {
                    title: lang.menu?.assetLocation || "Vị trí tài sản",
                    activeClass: "asset-location",
                    parentClass: "asset-management",
                    icon: "caret",
                    url: '/ad-sas-school/vi-tri-tai-san',
                    // permission: "ASTL0",
                    permission: "MED0",
                    isShow: false,
                },
                {
                    title: lang.menu?.assetList || "Danh sách tài sản",
                    activeClass: "asset-list",
                    parentClass: "asset-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-tai-san',
                    // permission: "AST0",
                    permission: "MED0",
                    isShow: false,
                },
                {
                    title: lang.menu?.assetMaintenance || "Bảo trì tài sản",
                    activeClass: "asset-maintenance",
                    parentClass: "asset-management",
                    icon: "caret",
                    url: '/ad-sas-school/bao-tri-tai-san',
                    // permission: "ASTM0",
                    permission: "MED0",
                    isShow: false,
                },
                {
                    title: lang.menu?.assetCheckout || "Mượn/Trả tài sản",
                    activeClass: "asset-checkout",
                    parentClass: "asset-management",
                    icon: "caret",
                    url: '/ad-sas-school/muon-tra-tai-san',
                    // permission: "ASTCK0",
                    permission: "MED0",
                    isShow: false,
                },
                {
                    title: lang.menu?.assetDepreciation || "Khấu hao tài sản",
                    activeClass: "asset-depreciation",
                    parentClass: "asset-management",
                    icon: "caret",
                    url: '/ad-sas-school/khau-hao-tai-san',
                    // permission: "ASTDP0",
                    permission: "MED0",
                    isShow: false,
                },
            ]
        },
        {
            title: lang.menu?.procurementManagement || "Quản lý mua sắm",
            activeClass: "procurement-management",
            icon: "fas fa-shopping-cart font-18 icon-side-bar",
            permission: "PRC0",
            isShow: false,
            children: [
                {
                    title: lang.menu?.purchaseRequest || "Yêu cầu mua hàng",
                    activeClass: "purchase-request",
                    parentClass: "procurement-management",
                    icon: "caret",
                    url: '/ad-sas-school/yeu-cau-mua-hang',
                    permission: "PRC0",
                    isShow: false,
                },
                {
                    title: lang.menu?.purchaseOrder || "Đơn đặt hàng",
                    activeClass: "purchase-order",
                    parentClass: "procurement-management",
                    icon: "caret",
                    url: '/ad-sas-school/don-dat-hang',
                    permission: "PRC0",
                    isShow: false,
                },
                {
                    title: lang.menu?.goodsReceipt || "Phiếu nhận hàng",
                    activeClass: "goods-receipt",
                    parentClass: "procurement-management",
                    icon: "caret",
                    url: '/ad-sas-school/phieu-nhan-hang',
                    permission: "PRC0",
                    isShow: false,
                },
            ]
        },
    ],
    AdminSchoolQLTS: [
    ]
};

export default MenuItems
